/**
 * @typedef {Object} CustomCouplingRule
 * @property {ISO8601} validTo - ISO time when custom coupling rule should not apply any-more
 * @property {string} customCouplingRuleId - The ID of the custom coupling rule
 * @property {string} assetId - The ID of the wfObject asset
 * @property {string} vehicleId - The ID of the wfObject vehicle
 * @property {string} ruleType - Type of custom coupling rule (see CustomCouplingRule)
 *
 * @readonly
 * @enum {string}
 */
export const CustomCouplingRuleModel = Object.freeze({
    CUSTOM_COUPLING_RULE_ID: 'customCouplingRuleId',
    VEHICLE_ID: 'vehicleObjectId',
    ASSET_ID: 'assetObjectId',
    RULE_TYPE: 'ruleType',
    VALID_TO: 'validTo'
})
